import { render, staticRenderFns } from "./CallingScreen.vue?vue&type=template&id=341343fa&"
import script from "./CallingScreen.vue?vue&type=script&lang=js&"
export * from "./CallingScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports